export { default as AreaIcon } from './Area';
export { default as ArrowCarIcon } from './ArrowCar';
export { default as ArrowDownIcon } from './ArrowDown';
export { default as ArrowLeftIcon } from './ArrowLeft';
export { default as ArrowRightIcon } from './ArrowRight';
export { default as ArrowUpIcon } from './ArrowUp';
export { default as BatteryIcon } from './Battery';
export { default as BellIcon } from './Bell';
export { default as DtcIcon } from './Dtc';
export { default as HeartIcon } from './Heart';
export { default as LockIcon } from './Lock';
export { default as MarkerHeartIcon } from './MarkerHeart';
export { default as MarkerLockbeatIcon } from './MarkerLockbeat';
export { default as MarkerNoLockbeatIcon } from './MarkerNoLockbeat';
export { default as MarkerOnIcon } from './MarkerOn';
export { default as ParkedIcon } from './Parked';
export { default as ToolIcon } from './Tool';
export { default as WarningIcon } from './Warning';
export { default as SwapIcon } from './Swap';
export { default as FuelIcon } from './Fuel';
export { default as CoolantIcon } from './Coolant';
export { default as OdometerIcon } from './Odometer';
export { default as OilIcon } from './Oil';
export { default as MagnifierIcon } from './Magnifier';
export { default as ExternalIcon } from './External';
export { default as UserIcon } from './User';
export { default as CloseIcon } from './Close';
export { default as RoadIcon } from './Road';
export { default as UpdateIcon } from './Update';
export { default as FilterIcon } from './Filter';
export { default as DownloadIcon } from './Download';
export { default as NewgroupIcon } from './Newgroup';
export { default as CarsQueueIcon } from './CarsQueue';
export { default as PencilIcon } from './Pencil';
export { default as ChupaChups } from './ChupaChups';

export { default as LogoutIcon } from './Logout';
export { default as OverspeedIcon } from './Overspeed';
export { default as NightIcon } from './Night';
export { default as DayIcon } from './Day';
export { default as ExternalLinkIcon } from './ExternalLink';
export { default as CrashIcon } from './Crash';
export { default as TheftIcon } from './Theft';
export { default as MailIcon } from './Mail';
export { default as PhoneIcon } from './Phone';
export { default as MarkerBellIcon } from './MarkerBell';
export { default as MarkerEmptyIcon } from './MarkerEmpty';
export { default as MarkerStarIcon } from './MarkerStar';
export { default as LegendGenericIcon } from './LegendGeneric';
export { default as LegendGarageIcon } from './LegendGarage';
export { default as LegendParkingLotIcon } from './LegendParkingLot';
export { default as TripStartIcon } from './TripStart';
export { default as TripEndIcon } from './TripEnd';
export { default as TripPreviewIcon } from './TripPreview'
export { default as DiscardIcon } from './Discard';
export { default as ConfirmIcon } from './Confirm';
export { default as InfoCircleIcon } from './InfoCircle';
export { default as InfoCircleOutlineIcon } from './InfoCircleOutline';
export { default as EmptyMarkerA2 } from './EmptyMarkerA2';
export { default as EmptyMarkerB2 } from './EmptyMarkerB2';
export { default as RpmIcon } from './Rpm';
export { default as GraphIcon } from './Graph';
export { default as MarkerOverRpmIcon } from './MarkerOverRpm';
export { default as MarkerTripStartIcon } from './MarkerTripStart';
export { default as MarkerTripEndIcon } from './MarkerTripEnd';
export { default as NotificationTrayIcon } from './NotificationTray';
export { default as MapIcon } from './Map';
export { default as MenuIcon } from './Menu';
export { default as NoteIcon } from './Note';

export { default as SavingsIcon } from './Savings';
export { default as CreditCardIcon } from './CreditCard';


export { default as MapGeofenceIcon } from './MapGeofence';
export { default as MapGeofenceCircleIcon } from './MapGeofenceCircle';
export { default as MapGeofenceSquareIcon } from './MapGeofenceSquare';
export { default as MapGeofenceCustomPolygonIcon } from './MapGeofenceCustomPolygon';
export { default as VehicleAddIcon } from './VehicleAdd';
export { default as UserAddIcon } from './UserAdd';
export { default as TrashIcon } from './Trash';
export { default as AssignIcon } from './Assign'
export { default as EditIcon } from './Edit'
export { default as DeleteIcon } from './Delete'



// WEBPACK FOOTER //
// ./src/common/icons/index.js